import { themes } from '@/mocks/homeContent';

export default function ThemeLibrary() {
  const colors = ['bg-primary-500', 'bg-accent-500', 'bg-secondary-500', 'bg-foreground-900', 'bg-accent-600', 'bg-primary-600'];
  const tones = ['text-primary-600', 'text-accent-600', 'text-secondary-600', 'text-foreground-700', 'text-accent-700', 'text-primary-700'];

  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-10 flex flex-col gap-4 md:mb-14 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-primary-600">
              <span className="h-px w-8 bg-primary-500"></span> Theme Index
            </span>
            <h2 className="mt-3 font-display text-3xl font-black text-foreground-950 md:text-4xl">
              按题材逛 <span className="text-primary-600">·</span> 想看哪块直接进
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-600">
            以题材为索引的专题库，每个主题下面都沉淀了一批高热度合集，按需取用。
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {themes.map((t, i) => (
            <a
              key={t.name}
              href="#library"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-all hover:border-background-300 hover:bg-background-50 cursor-pointer md:p-6"
            >
              <span className={`h-1.5 w-8 rounded-full ${colors[i % colors.length]} transition-all group-hover:w-12`}></span>
              <span className="mt-5 font-display text-3xl font-black leading-none text-foreground-950">{t.name}</span>
              <span className="mt-1.5 text-[10px] font-bold uppercase tracking-[0.2em] text-secondary-500">{t.en}</span>
              <span className={`mt-3 text-[11px] leading-relaxed ${tones[i % tones.length]}`}>{t.desc}</span>
              <span className="mt-4 flex items-end justify-between border-t border-background-200 pt-3">
                <span className="font-display text-2xl font-black tabular text-foreground-900">
                  {t.count}
                </span>
                <span className="text-[10px] text-foreground-500">条专题</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}